<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading" epub:type="z3998:published-works" id="also-by">
<div class="heading heading-container-single heading-size-small heading-format-reduced heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-mixed">Also by Sarah Sheridan</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<p class="first first-in-chapter first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">The Sister Veronica Mysteries:</span></span></b></p>
<p class="subsq also-by-content"><span class="content-external-link">The Convent (book one)</span></p>
<p class="subsq also-by-content"><span class="content-external-link">The Disciple (book two)</span></p>
<p class="subsq also-by-content"><span class="content-external-link">The Tormented (book three)</span></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-563">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-rule-gradient-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><span class="content-external-link">Devil’s Play</span></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-563">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-rule-gradient-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><a class="content-external-link" href="https://geni.us/GirlInBedThree" target="_blank">Girl in Bed Three</a></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-563">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-rule-gradient-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><a class="content-external-link" href="https://alsoby.me/r/kobo/a-perfect-family" target="_blank">A Perfect Family</a></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-563">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-rule-gradient-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><a class="content-external-link" href="http://mybook.to/TheTemptressSS" target="_blank">The Temptress</a> (novella)</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsobysarahsheridan.vue?b7aa320e